import { IRequest } from "coral-utility";
import { GenericMap, QueryFilter } from "state/ducks/models/types";
import { Model } from "types";

export const FIELDS_TO_SEARCH = [
  "modelType",
  "modelTags",
  "analysisTags",
  "programAndVersion",
  "tags",
  "isModel",
  "isRadNuc",
  "isBio",
  "isChem",
];

export const models = {
  getModel: (modelId: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/model/${modelId}`,
    options: {
      method: "GET",
    },
  }),
  getBuckets: (
    searchText?: string,
    filters?: GenericMap<QueryFilter>,
    fields: string[] = FIELDS_TO_SEARCH
  ): IRequest => ({
    route: () =>
      `${process.env.REACT_APP_API_URI}/api/model/buckets${
        searchText ? `/${searchText}` : ""
      }`,
    options: {
      method: "POST",
      body: JSON.stringify({ fields, filters }),
    },
  }),
  search: (
    query: string,
    searchText?: string,
    filters?: GenericMap<QueryFilter>,
    fields: string[] = FIELDS_TO_SEARCH
  ): IRequest => ({
    route: () =>
      `${process.env.REACT_APP_API_URI}/api/model/search${
        searchText ? `/${searchText}` : ""
      }?${query}&include_files=true`,
    options: {
      method: "POST",
      body: JSON.stringify({ fields, filters }),
    },
  }),
  new: (model: FormData): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/model/new`,
    options: {
      method: "POST",
      body: model,
    },
  }),
  edit: (model: FormData, modelId: string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/model/${modelId}/edit`,
    options: {
      method: "POST",
      body: model,
    },
  }),
  fileDownload: (id:string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/file/download/${id}`,
    options: {
      method: "POST",
    },
  }),
  deleteModel: (id:string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/model/${id}`,
    options: {
      method: "DELETE",
    },
  }),
  getModelVersions: (modelId:string): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/model/${modelId}/versions`,
    options: {
      method: "GET",
    },
  }),
  cloneModel: (model: Partial<Model>): IRequest => ({
    route: () => `${process.env.REACT_APP_API_URI}/api/model/${model.id}/clone`,
    options: {
      method: "POST",
      body: JSON.stringify(model),
    },
  }),
};
